import AxiosInstance from 'utils/AxiosInstance'

import * as types from './types'
import { fetchUserProgress } from 'store/Course/actions'
import { fetchUser } from 'store/Users/actions'
import { setProgress } from 'store/EmployeeReport/actions'
import { isLoading } from 'store/EmployeeReport/actions'
import { LOADING } from 'store/EmployeeReport/constants'
import { refetchManagerReportsCourses } from 'store/ManagerReport/actions'
import { setNavbarNotifications } from 'store/Notifications/actions'
import { fetchNotifications } from 'store/Notifications/actions'
/*eslint-disable */
export const quiz = (data, shuffle) => {
  return (dispatch, getState) => {
    if (window.location.href.includes('content-quiz')) return

    if (data) {
      const quiz = JSON.parse(JSON.stringify(data))
      const questions = quiz.questions_left
        ? quiz.questions_left.slice()
        : quiz.questions
      const newQuestions =
        shuffle && questions
          ? questions.map((item) => {
              if (
                item.type === 4 ||
                ((item.type === 2 || item.type === 3) && data.randomizeOrder)
              ) {
                let randomOptions = item.options.slice()

                for (
                  let index = randomOptions.length - 1;
                  index >= 0;
                  index--
                ) {
                  let randomIndex = Math.floor(Math.random() * (index + 1))
                  let itemAtIndex = randomOptions[randomIndex]

                  randomOptions[randomIndex] = randomOptions[index]
                  randomOptions[index] = itemAtIndex
                }

                item.options = randomOptions
              }
              return item
            })
          : questions

      quiz.questions = newQuestions
      dispatch({ type: types.QUIZ, data: quiz })
    }
  }
}

let timeout = 0
const save = () => {
  return (dispatch, getState) => {
    clearTimeout(timeout)

    const { id } = getState().courses
    const { questions } = getState().quizes
    AxiosInstance.post(`/courses/${id}/submissions`, {
      quiz: JSON.stringify(questions),
    })
  }
}

export const changeScore = (index, score) => {
  return (dispatch, getState) => {
    const { gradedQuestions: questions } = getState().quizes

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], score },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.SET_GRADED_QUESTIONS, questions: nextQuestions })
    // dispatch(save())
  }
}

export const addGridQuestionsScores = (scores, questionId) => {
  return (dispatch, getState) => {
    const { gradedQuestions: questions } = getState().quizes

    const index = questions.findIndex((q) => q.id === questionId)

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], scores },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.SET_GRADED_QUESTIONS, questions: nextQuestions })
  }
}

export const setGradedQuestions = (questions) => ({
  type: types.SET_GRADED_QUESTIONS,
  questions,
})

export const saveGrade = (courseId, user) => {
  return (dispatch, getState) => {
    const { progress } = getState().employeeReport
    const item = progress.find((item) => item.isShowing)
    const activeIndex = progress.findIndex((item) => item.isShowing)

    const { gradedQuestions } = getState().quizes
    AxiosInstance.put(`/courses/${courseId}/submissions`, {
      user,
      quiz: JSON.stringify(gradedQuestions),
    }).then((data) => {
      const newProgress = [
        ...progress.slice(0, activeIndex),
        { ...item, status: data.status },
        ...progress.slice(activeIndex + 1),
      ]

      dispatch(setProgress({ progress: newProgress }))
      dispatch(isLoading(LOADING, 'isLoading', false))
      dispatch(refetchManagerReportsCourses())
      dispatch(fetchNotifications())
      dispatch(setNavbarNotifications())
    })
  }
}

export const fetchSubmission = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/courses/${id}/submissions`).then((data) => {
      if (data && data.quiz) {
        dispatch(
          quiz({
            questions: data.questions_left
              ? data.questions_left
              : data.questions,
            submissions: data.quiz,
            last_questions_left: data.last_questions_left,
            status: data.quiz_status,
            quiz_score: data.quiz_score,
            message: data.message,
            quiz_pass_percentage: data.quiz_pass_percentage,
            quiz_score_percentage: data.quiz_score_percentage,
            quizPassed: data.quiz_passed,
            quizAttempts: data.quiz_attempts,
            quizOpened: data.quiz_opened,
          })
        )
        dispatch({ type: types.SUBMIT_QUIZ, submitted: false })
      }
    })
  }
}

export const onSubmit = (noConfirms = false) => {
  const quizSubmitRequest = (course_id, questions, last_questions_left) => {
    return AxiosInstance.post(`/courses/${course_id}/submissions`, {
      quiz: JSON.stringify(questions),
      quiz_status: last_questions_left ? 2 : 1,
    })
  }

  return (dispatch, getState) => {
    const { course_id } = getState().courses
    const { questions, last_questions_left } = getState().quizes
    const answered = []
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (questions && questions.length) {
      questions.map((item) => {
        if (
          item.type === 4 ||
          (item.options &&
            item.options.filter((item) => item.selected).length) ||
          item.type === 7 ||
          item.type === 8
        ) {
          answered.push(1)
        } else {
          answered.push(0)
        }
      })
    }
    if (noConfirms) {
      quizSubmitRequest(course_id, questions, last_questions_left).then(() => {
        dispatch(fetchUserProgress())
      })
    } else if (answered.includes(0)) {
      if (
        confirm(
          language.alerts
            ? language.alerts.submit_quiz_confirm_not_all_answers
            : null
        )
      ) {
        quizSubmitRequest(course_id, questions, last_questions_left).then(
          () => {
            dispatch(fetchUserProgress())
            dispatch(onClick(0))
            dispatch(fetchSubmission(course_id))
            dispatch({ type: types.SUBMIT_QUIZ, submitted: true })
          }
        )
      }
    } else {
      if (
        confirm(language.alerts ? language.alerts.submit_quiz_confirm : null)
      ) {
        quizSubmitRequest(course_id, questions, last_questions_left).then(
          () => {
            dispatch(fetchUserProgress())
            dispatch(onClick(0))
            dispatch(fetchSubmission(course_id))
            dispatch({ type: types.SUBMIT_QUIZ, submitted: true })
          }
        )
      }
    }
  }
}

export const onChange = (nextOptionIndex) => {
  return (dispatch, getState) => {
    const { index, questions } = getState().quizes
    console.log(index, 'index in onchange')
    const options = questions[index].options
    const optionIndex = options.findIndex((item) => item.selected)

    if (optionIndex === nextOptionIndex) {
      return
    }

    let nextOptions = options

    if (optionIndex !== -1) {
      const { selected, ...option } = options[optionIndex]

      nextOptions = [
        ...options.slice(0, optionIndex),
        option,
        ...options.slice(optionIndex + 1),
      ]
    }

    nextOptions = [
      ...nextOptions.slice(0, nextOptionIndex),
      { ...nextOptions[nextOptionIndex], selected: true },
      ...nextOptions.slice(nextOptionIndex + 1),
    ]

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], options: nextOptions },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: nextQuestions })
    dispatch(save())
  }
}

export const onChangeCheckbox = (nextOptionIndex) => {
  return (dispatch, getState) => {
    const { index, questions } = getState().quizes
    const options = questions[index].options

    const nextOptions = [
      ...options.slice(0, nextOptionIndex),
      {
        ...options[nextOptionIndex],
        selected: !options[nextOptionIndex].selected,
      },
      ...options.slice(nextOptionIndex + 1),
    ]

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], options: nextOptions },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: nextQuestions })
    dispatch(save())
  }
}

export const changeParagraph = (answer) => {
  return (dispatch, getState) => {
    const { index, questions } = getState().quizes

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], answer },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: nextQuestions })
    dispatch(save())
  }
}

export const changeGridAnswer = (tableData) => {
  return (dispatch, getState) => {
    const { index, questions } = getState().quizes

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], tableData },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: nextQuestions })
    dispatch(save())
  }
}

export const onChangeSelect = (event, matchString = '') => {
  return (dispatch, getState) => {
    const { index } = getState().quizes
    let { questions } = getState().quizes

    if (!Array.isArray(questions)) {
      questions = [questions]
    }

    const options = questions[index].options
    const mergedId = event.target.value
    const answerId = mergedId ? mergedId.split(' ')[0] : ''
    const matchId = mergedId
      ? mergedId.split(' ')[1] !== '--'
        ? mergedId.split(' ')[1]
        : ''
      : ''
    const option = options.find((option) => option.id === answerId)
    mergedId.length === 0
      ? option
        ? (option.selected = '')
        : null
      : option
      ? (option.selected = matchString ? matchString : matchId)
      : null

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], options: options },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: nextQuestions })
    dispatch(save())
  }
}

export const reorderOptions = (reorderOptions) => {
  return (dispatch, getState) => {
    const { index, questions } = getState().quizes

    const newQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], options: reorderOptions },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: newQuestions })
    dispatch(save())
  }
}

export const resetQuiz = () => ({ type: types.RESET_QUIZ })
export const onClick = (index) => ({ type: types.ACTIVE_QUESTION, index })

export const setQuizTimer = (count) => {
  return (dispatch) => {
    dispatch({ type: types.SET_QUIZ_TIMER, count })
  }
}
export const onEndCount = () => {
  return (dispatch) => {
    dispatch({ type: types.ON_END_COUNT, countEnded: true })
    dispatch(onSubmit(true))
  }
}

export const onQuizOpen = () => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    const quiz_opened = 1
    AxiosInstance.put(
      `courses/${course_id}/opened-submission`,
      quiz_opened
    ).then(() => {
      // dispatch(fetchSubmission(course_id))
    })
  }
}

export const onUnmount = (count) => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    dispatch(setQuizTimer(count))
    dispatch(fetchSubmission(course_id))
  }
}

export const setQuizCloseOverlay = (value) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_CLOSE_QUIZ_OVERLAY,
      isQuizOverlayClosed: value,
    })
  }
}

export const closeQuizOverlay = (callbackFn = null) => {
  return (dispatch, getState) => {
    const { quizCount, countEnded } = getState().quizes
    if (
      confirm(
        "Are you sure you want to close the quiz overlay? Once you close it your time will be over, the quiz will be submitted and you can not take the quiz anymore. Click 'cancel' to stay in the quiz, click 'OK' to leave"
      )
    ) {
      dispatch(onSubmit())
      if (callbackFn) {
        callbackFn()
      }
    }
  }
}

export const postSubmit = () => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    const { questions } = getState().quizes
    AxiosInstance.post(`/courses/${course_id}/submissions`, {
      quiz: JSON.stringify(questions),
    })
  }
}
